import Text from '../../../atoms/Text';
import { IMobileTableScema } from '../../../helpers/formatters';

import './styles.scss';

interface ITableHeaderProps {
  schema: IMobileTableScema;
}

const TableHeaderMobile = ({ schema }: ITableHeaderProps) => {
  const headers = Object.values(Object.values(schema)[0]);
  return (
    <div className='table_mobile__card'>
      <div className='table_mobile__card__content__row'>
        {headers.map(({ accessor, width, name }) => (
          <div
            key={accessor}
            style={{ width, minWidth: width }}
            className='table_mobile__card__content__row__item'
          >
            <div className='table_mobile__card__content__row__item__text'>
              <Text
                size={12}
                className='table_mobile__card__content__row__item__text__header'
              >
                {name}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableHeaderMobile;
